/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {makeStyles} from '@material-ui/core/styles';
import {DLSTheme} from '@ion/dls/src/types/types';

export const useStyles = makeStyles((theme: DLSTheme) => ({
  treeItemContainer : {
    display       : 'flex',
    flexDirection : 'column',
    paddingBottom : 0,
    paddingTop    : 0
  },
  collapseContainer : {
    width : '100%'
  },
  paddedListElement : {
    paddingLeft : 10
  },
  checkBoxLabel : {
    marginRight : 8
  },
  listContainer : {
    minHeight : 40,
    padding   : 0
  },
  treeItemLabel : {
    display       : 'flex',
    flexDirection : 'row',
    height        : 40,
    alignItems    : 'center',
    cursor        : 'pointer',
    '&:hover'     : {
      backgroundColor : theme.dls.colors.grey5
    }
  }
}));
